import { ClientLabel } from 'labels/client'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { BankDataForm } from 'refunds/containers/BankDataForm/BankDataForm'
import type { BankDataInfo, RefundData } from 'refunds/types/refundData'
import { useResponsive } from 'responsive/hooks/useResponsive/useResponsive'

import style from './BankDataFormContainer.module.scss'
import text from 'fukku/styles/texts.module.scss'

interface BankDataFormContainerProps {
	readonly refundData?: RefundData
	readonly handleOnError?: () => void
	readonly handleOnSave?: (values: BankDataInfo) => void
	readonly handleOnSubmit?: (values: BankDataInfo) => void
	readonly validateWithoutSave?: boolean
	readonly showTitle?: boolean
	readonly overrideButtonText?: string
}

export function BankDataFormContainer({
	refundData,
	handleOnError,
	handleOnSave,
	handleOnSubmit,
	validateWithoutSave,
	showTitle,
	overrideButtonText,
}: BankDataFormContainerProps) {
	const { t } = useLabels()
	const { isSmall } = useResponsive()
	return (
		<div className={style.content}>
			<div className={style.header}>
				{showTitle && (
					<p className={`${style.title} ${text.titleM}`}>
						{t('myRefunds.bankDetails.title')}
					</p>
				)}
				{(showTitle || isSmall) && (
					<p className={style.subtitle}>
						{t('myRefunds.bankDetails.subtitle')}
					</p>
				)}
			</div>

			<BankDataForm
				preloadData={refundData}
				onError={handleOnError}
				onSaveData={handleOnSave}
				onSubmit={handleOnSubmit}
				validateWithoutSave={validateWithoutSave}
				overrideButtonText={overrideButtonText}
			/>

			<div className={`${text.bodyS} ${style.details}`}>
				<p>{t('myRefunds.bankDetails.checkDetails.text')}</p>
				<p className={style.legalText}>
					<ClientLabel
						placeholderValues={{ privacyPolicy: '/privacy-policy' }}
						linkProps={{ className: style.link }}
					>
						{t('myRefunds.privacy.legal')}
					</ClientLabel>
				</p>
			</div>
		</div>
	)
}
